export const applyPhoneMask = (originalValue, mask = '(***) ***-****') => {
  if (!originalValue) {
    return '';
  }

  const value = originalValue.replace(/\D/g, '');

  const starCount = mask.split('').filter((c) => c === '*').length;
  if (value.length !== starCount) {
    return originalValue;
  }

  // iterate through mask ->  replace mask * with digits
  let result = '';
  let maskIndex = 0;
  let valueIndex = 0;
  while (maskIndex < mask.length && valueIndex < value.length) {
    if (mask[maskIndex] === '*') {
      result += value[valueIndex];
      valueIndex += 1;
    } else {
      result += mask[maskIndex];
    }
    maskIndex += 1;
  }

  return result;
};

export const toMaxFixed = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return null;
  }

  const numValue = Number(value);
  const fixed = numValue.toFixed(decimalPlaces);

  if (fixed.indexOf('.') !== -1) {
    return fixed.replace(/0+$/, '').replace(/\.$/, '');
  }

  return fixed;
};

// Build truck info strings
export const buildTruckDescriptionString = (truck) => {
  if (!truck) {
    return '';
  }

  const {
    makeName, modelName, year, color,
  } = truck;

  const str = [makeName, modelName, year].filter((s) => s && s !== '').join(', ');

  const hasColor = color && color !== '';

  return hasColor ? `${str === '' ? color : `${str} - ${color}`}` : str;
};

export const buildTruckPlateString = (truck) => {
  if (!truck) {
    return '';
  }

  const { licensePlateNumber, licensePlateStateName } = truck;

  const str = [licensePlateNumber, licensePlateStateName].filter((s) => s && s !== '').join(' - ');

  return str;
};

export const camelCaseToSentenceCase = (str) => {
  const result = str.replace(/([A-Z0-9])/g, ' $1').trim();
  return result.charAt(0).toUpperCase() + result.slice(1);
};